import { Container, Grid } from "@mui/material"
import Header from "components/Header"
import Footer from "components/Footer"

interface Props {
  id: string,
  children: any
}

const Page = ({ id, children }: Props) => {
  return (
    <>
      <Grid container wrap="wrap">
        <Header context={id}/>
        <Grid item xs={12} sm={12} md={12}>
          <Container maxWidth={false} disableGutters>
            {children}
          </Container>
          <Footer/>
        </Grid>
      </Grid>
    </>
  )
}

export default Page